import './main.less';
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classname';

import Logo from './logo/main';
import Menu from './menu/main';
import Buttons from './buttons/main';
import Top from './top/main';
import Bottom from './bottom/main';

const propTypes = {
	opened: PropTypes.bool,
	intl: PropTypes.func,
	toggleOpened: PropTypes.func,
	children: PropTypes.oneOfType([
		PropTypes.arrayOf(PropTypes.node),
		PropTypes.node
	])
};
const defaultProps = {
	opened: true,  // TODO: take from screen width
	intl: t => t
};

class Sidebar extends React.Component {
	constructor(props) {
		super(props);
	}
	render() {
		const { opened, toggleOpened, intl, children } = this.props;
		return (<div className={cn('main-menu', opened && 'main-menu--opened')}>
			{children}
			<div onClick={toggleOpened} className="main-menu__close">
				<div className="main-menu__close-txt">{intl('Close panel')}</div>
				<div className="main-menu__close-ico" />
			</div>
		</div>);
	}
}

Sidebar.propTypes = propTypes;
Sidebar.defaultProps = defaultProps;

Sidebar.Logo = Logo;
Sidebar.Menu = Menu;
Sidebar.Buttons = Buttons;
Sidebar.Top = Top;
Sidebar.Bottom = Bottom;

export { Logo, Menu, Buttons, Top, Bottom };
export default Sidebar;




// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/sidebar/components/main.js